import { isTableauAppendRowsArg } from '../../tableau-types';
import { reportErrorReason } from "../helpers/general-helpers";
var Groups = /** @class */ (function () {
    function Groups() {
        this.id = 'groups';
        this.alias = 'Customer Groups';
    }
    Groups.prototype.getData = function (connector, table, done) {
        connector
            .getApiClient()
            .fetchCustomerGroups()
            .then(function (response) { return response.json(); })
            .then(function (data) {
            if (isTableauAppendRowsArg(data.data)) {
                table.appendRows(data.data);
            }
            else {
                throw new Error('Unknown Group data format');
            }
        })
            .then(done)
            .catch(function (reason) { return reportErrorReason(reason, connector.getTableau()); });
    };
    Groups.prototype.getTableInfo = function () {
        return {
            id: this.id,
            alias: this.alias,
            columns: [
                {
                    id: 'group_id',
                    dataType: 'int',
                    alias: 'Group ID',
                    description: 'The ID used by Sprout to identify this group.',
                },
                {
                    id: 'name',
                    dataType: 'string',
                    alias: 'Name',
                    description: 'The name of the group',
                },
            ],
        };
    };
    return Groups;
}());
export default Groups;
